import dynamic from 'next/dynamic';
import Image from 'next/image';

import { useTextFontOverrides, useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import type { ComponentsHero } from 'queries/graphql';

import RatingStars from 'generic/RatingStars';

const MarkdownText = dynamic(() => import('generic/MarkdownText'));

import styles from './styles.module.scss';

export default function Hero({
  image,
  ratingText,
  heading,
  subheading,
  text,
  badges,
  rating,
  style,
}: ComponentsHero) {
  const { headingColor, subheadingColor, textColor, ratingTextColor, headingFont, textFont } =
    style || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);
  const textFontOverrides = useTextFontOverrides(textFont);
  return (
    <div className={`root ${styles.hero_container}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--heading-color', headingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--subheading-color', subheadingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--rating-text-color', ratingTextColor, 'var(--text-color-dark)')}
          ${headingFontOverrides ?? ''}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      <div className={styles.img_wrapper}>
        <Image {...buildImgProps(image)} alt={image?.alt} />
      </div>
      <div className={styles.hero_content}>
        <div className={styles.hero_reviews}>
          {!!rating && <RatingStars className={styles.stars} rating={rating} style={style} />}
          {ratingText && (
            <div className={styles.rating_text}>
              <MarkdownText text={ratingText} />
            </div>
          )}
        </div>
        <h1>{heading}</h1>
        {subheading && <h2>{subheading}</h2>}

        <MarkdownText text={text} />

        {badges.length !== 0 && (
          <div className={styles.hero_logo_container}>
            {badges.map(item => (
              <div key={item.id}>
                <Image {...buildImgProps(item.image)} alt={item.image?.alt} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
